<template>
  <div>
    <v-dialog
      v-model="closeEventDialog"
      transition="dialog-bottom-transition"
      max-width="800px"
    >
      <v-card>
        <v-toolbar
          dark
          flat
          color="secondary"
        >
          <v-btn
            icon
            dark
            @click.native="closeEventDialog = false"
          >
            <v-icon>close</v-icon>
          </v-btn>
          <v-toolbar-title>סיום אירוע</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn
            dark
            flat
            large
            :loading="closing"
            :disabled="closing"
            @click.native="closeEvent"
          >
            שמירה
          </v-btn>
        </v-toolbar>
        <v-form
          ref="form"
          v-model="valid"
          lazy-validation
        >
          <v-layout row wrap>
            <v-flex xs12>
              <v-card-text>
              <!-- Partners -->
             
              <div v-if="existingPartners && existingPartners.length" class="mb-3">
                <div class="caption mb-1">ספקים קיימים באירוע:</div>
                <v-chip
                  v-for="partner in existingPartners"
                  :key="partner._id"
                  class="ma-1"
                  small
                  color="secondary"
                  text-color="white"
                >
                  {{ partner.name || 'ללא שם' }}
                </v-chip>
              </div>

              <!-- Required end date -->
              <v-text-field
                type="datetime-local"
                v-model="endDate"
                label="זמן סיום *"
                :rules="dateRules"
              ></v-text-field>

              <!-- Title -->
              <v-text-field
                v-model="formData.title"
                label="כותרת *"
                :rules="[v => !!v || 'חובה להזין כותרת']"
              ></v-text-field>


             
               <!-- ARAN -->
              <v-container
                fluid
                grid-list-md
                style="border: 2px solid red; padding: 10px; margin: 10px 0;"
              >
                <div class="headline mb-2">אר"ן </div>
                <v-layout
                  row
                  wrap
                >
                  <v-flex
                    xs12
                  >
                    <v-radio-group
                      v-model="aranOption"
                      class="mb-3"
                      @change="onAranOptionChange"
                    >
                      <v-radio
                        label="ללא ארן"
                        value="none"
                        class="mb-2"
                      ></v-radio>
                      <v-radio
                        label="ארן חדש"
                        value="new"
                        class="mb-2"
                      ></v-radio>
                      <v-radio
                        label="הוספה לארן קיים"
                        value="existing"
                        class="mb-2"
                      ></v-radio>
                    </v-radio-group>
                  </v-flex>
                  <v-flex
                    xs12
                    sm6
                    v-if="aranOption === 'new'"
                  >
                    <v-text-field
                      v-model="newAranName"
                      label="שם ארן חדש"
                      placeholder="הזן שם ארן חדש"
                      outlined
                      dense
                    ></v-text-field>
                  </v-flex>
                  <v-flex
                    xs12
                    sm6
                    v-if="aranOption === 'existing'"
                  >
                    <v-autocomplete
                      v-model="selectedAran"
                      :items="arans"
                      item-text="name"
                      item-value="_id"
                      label="בחר ארן קיים"
                      :loading="loadingArans"
                      :disabled="loadingArans"
                      outlined
                      dense
                    >
                      <template
                        slot="selection"
                        slot-scope="{ item, index }"
                      >
                        {{ item.name }}
                      </template>
                    </v-autocomplete>
                  </v-flex>
                  <!-- Debug info -->
                  <v-flex xs12 v-if="aranOption">
                    <small class="text-muted">Debug: Selected option: {{ aranOption }}</small>
                  </v-flex>
                </v-layout>
              </v-container>



              <!-- Event Type -->
              <v-select
                v-model="formData.type"
                :items="types"
                item-text="title"
                item-value="_id"
                label="סוג אירוע *"
                :rules="[v => !!v || 'חובה לבחור סוג אירוע']"
              ></v-select>

              <!-- Event SubType -->
              <v-select
                v-model="formData.subType"
                :items="subTypes"
                item-text="title"
                item-value="_id"
                label="תת סוג אירוע"
              ></v-select>

              <!-- Source -->
              <v-select
                v-model="formData.source"
                :items="sources"
                item-text="title"
                item-value="_id"
                label="מקור אירוע *"
                :rules="[v => !!v || 'חובה לבחור מקור אירוע']"
              ></v-select>

              <!-- Countries -->
              <v-select
                v-model="formData.countries"
                :items="countries"
                item-text="name"
                item-value="_id"
                label="מדינות *"
                multiple
                :rules="[v => v.length > 0 || 'יש לבחור מדינה אחת לפחות']"
              ></v-select>

              <!-- Regions -->
              <v-select
                v-model="formData.regions"
                :items="regionsList"
                item-text="name"
                item-value="_id"
                label="איזורים"
                multiple
              ></v-select>

              <!-- Description -->
              <v-textarea
                v-model="formData.description"
                label="תיאור *"
                :rules="[v => !!v || 'חובה להזין תיאור']"
                placeholder="יש למלא עד משפט אחד קצר, שמסביר מה מהות האירוע. לדוגמא: נתקעו בסופת שלגים, חולצו על ידי מגן/ קלקול קיבה/ מלחקת גבהים"
                required
              ></v-textarea>

              <!-- Evacuation Type -->
              <v-select
                v-model="formData.evacuationType"
                :items="evacuationTypes"
                item-text="title"
                item-value="_id"
                label="אופן פינוי *"
                :rules="[v => !!v || 'חובה לבחור אופן פינוי']"
                required
              ></v-select>

              <!-- Included in Harel Reports -->
              <v-switch
                v-model="formData.includedInHarelReports"
                label="אירוע מוכר בהראל (לצורך דו״חות)"
              ></v-switch>

              <!-- Debriefing -->
              <v-switch
                v-model="formData.debriefing"
                label="האירוע תוחקר"
              ></v-switch>

              <!-- Partners list -->
              <div v-if="resolvedPartners && resolvedPartners.length" class="mb-3">
                <div class="caption mb-1">ספקים קיימים באירוע:</div>
                <v-chip
                  v-for="partner in resolvedPartners"
                  :key="partner._id"
                  class="ma-1"
                  small
                  color="secondary"
                  text-color="white"
                  close
                  @input="removePartner(partner._id)"
                >
                  {{ partner.name || 'ללא שם' }}
                </v-chip>
              </div>
              
              <v-checkbox
                v-model="formData.noPartners"
                label="אין ספק"
              ></v-checkbox>

              <!-- Partners action -->
              <div class="text-xs-right mt-3">
                <v-btn
                  small
                  color="secondary"
                  @click="openPartnersDialog"
                >
                  הוספת ספקים
                </v-btn>
              </div>
              </v-card-text>
            </v-flex>
          </v-layout>
        </v-form>
      </v-card>
    </v-dialog>

    <event-partners-dialog v-if="eventPartnersDialog" />
  </div>
</template>

<script>
import { format } from "date-fns";
import { getApi } from "@/api";
import EventPartnersDialog from "@/components/events/EventPartnersDialog";
export default {
  data() {
    return {
      closing: false,
      valid: true,
      dateRules: [],
      endDate: null,
      removingPartners: {},
      formData: {
        title: "",
        type: null,
        subType: null,
        source: null,
        countries: [],
        regions: [],
        description: "",
        evacuationType: null,
        includedInHarelReports: false,
        debriefing: false
      ,
      noPartners: false
      },

      // ARAN data
      aranOption: 'none',
      newAranName: '',
      selectedAran: null,
      arans: [],
      loadingArans: false,
      eventAranId: null,
    };
  },

  computed: {
    closeEventDialog: {
      get() {
        return this.$store.getters["events/closeEventDialog"];
      },
      set(isActive) {
        this.$store.commit("events/TOGGLE_CLOSE_EVENT_DIALOG", isActive);
      }
    },
    event() {
      return this.$store.state.entities.events[this.$route.params.id];
    },
    types() {
      const excluded = [
        'העברה לטיפול צוות אחר',
        'סיוע לרכב תקוע',
        'מנותק קשר',
        'אסון טבע',
        'אר"ן',
        'מצב רפואי הדורש פינוי',
        'רפואי נפשי'
      ];
      return this.$store.getters["entityList"]("eventTypes").filter(
        t => !excluded.includes(t.title)
      );
    },
    sources() {
      return this.$store.getters["entityList"]("eventSources");
    },
    countries() {
      return this.$store.getters["entityList"]("countries").filter(item => {
        return item.isActive;
      });
    },
    resolvedPartners() {
      const list = this.event && this.event.partners ? this.event.partners : [];
      return list
        .map(partner => {
          if (partner && partner.name) return partner;
          const id = partner && partner._id ? partner._id : partner;
          const entity = this.$store.getters["entity"]("partners", id);
          return entity ? entity : id ? { _id: id, name: "ללא שם" } : null;
        })
        .filter(Boolean);
    },
    eventPartnersDialog: {
      get() {
        return this.$store.getters["events/eventPartnersDialog"];
      },
      set(isActive) {
        this.$store.commit("events/TOGGLE_EVENT_PARTNERS_DIALOG", isActive);
      }
    },
    evacuationTypes() {
      return this.$store.getters["entityList"]("evacuationTypes");
    },
    subTypes() {
      if (!this.formData.type) return [];
      return this.$store.getters["events/typeSubTypes"](this.formData.type);
    },
    regionsList() {
      if (!this.formData.countries || !this.formData.countries.length) return [];
      return this.$store.getters["countries/countryRegions"](this.formData.countries);
    }
  },

  methods: {
    closeEvent() {
      if (this.$refs.form.validate()) {
            if (!this.resolvedPartners.length && !this.formData.noPartners) {
              this.$store.dispatch("SHOW_SNACKBAR", {
                text: 'יש להוסיף ספק או לסמן "אין ספק"',
                color: "error"
              });
              return;
            }

            this.closing = true;

        // Handle ARAN creation/selection first
        let aranPromise = Promise.resolve(null);
        
        if (this.aranOption === 'new' && this.newAranName) {
          // Create new ARAN
          aranPromise = getApi()
            .then(api => {
              return api.post("/aran", {
                name: this.newAranName
              });
            })
            .then(({ data }) => {
              console.log('New ARAN created:', data);
              return data._id; // Return the new ARAN ID
            })
            .catch(err => {
              console.log('Error creating ARAN:', err);
              this.$store.dispatch("SHOW_SNACKBAR", {
                text: err.response ? err.response.data.message : err.message,
                color: "error"
              });
              throw err;
            });
        } else if (this.aranOption === 'existing' && this.selectedAran) {
          // Use existing ARAN ID
          aranPromise = Promise.resolve(this.selectedAran);
        }

        // Continue with event closing after ARAN handling
        aranPromise
          .then(aranId => {
            // Store the ARAN ID for use in event closing
            this.eventAranId = aranId;
            
            return getApi();
          })
          .then(api => {
            this.closeEventDialog = false;
            let params = {
              endDate: new Date(this.endDate),
              ...this.formData
            };
            
            // Add ARAN ID if available
            if (this.eventAranId) {
              params.aran = this.eventAranId;
            }
            
            // Debug: Log the parameters being sent
            console.log('Closing event with params:', params);
            console.log('Evacuation type:', this.formData.evacuationType);
            
            return api.post(`/events/${this.$route.params.id}/close`, params);
          })
          .then((response) => {
            // After closing event and attaching to ARAN, trigger Google Sheets update
            // The backend should update Google Sheets with all customer data from all events in the ARAN
            if (this.eventAranId && response && response.data) {
              console.log('Event closed and attached to ARAN, Google Sheets should be updated by backend');
              // The backend should automatically update Google Sheets when event is closed with ARAN
              // If it doesn't, we might need a separate endpoint to trigger the update
            }
            return response;
          })
          .catch(err => {
            console.log(err);
            this.$store.dispatch("SHOW_SNACKBAR", {
              text: err.message,
              color: "error"
            });
          })
          .finally(() => {
            this.closing = false;
          });
      }
    },
    reset() {
      this.endDate = null;
      this.formData = {
        title: "",
        type: null,
        subType: null,
        source: null,
        countries: [],
        regions: [],
        description: "",
        evacuationType: null,
        includedInHarelReports: false,
        debriefing: false
        ,
        noPartners: false
      };
      
      // Reset ARAN fields
      this.aranOption = 'none';
      this.newAranName = '';
      this.selectedAran = null;
      this.eventAranId = null;
      this.eventPartnersDialog = false;
    },
    populateFromEvent() {
      if (this.event) {
        this.formData = {
          title: this.event.title,
          type: this.event.type,
          subType: this.event.subType,
          source: this.event.source,
          countries: this.event.countries || [],
          regions: this.event.regions || [],
          description: this.event.description,
          evacuationType: this.event.evacuationType,
          includedInHarelReports: this.event.includedInHarelReports || false,
          debriefing: this.event.debriefing || false
        ,
        noPartners: this.event.noPartners || false
        };

        // Handle existing ARAN
        if (this.event.aran) {
          this.aranOption = 'existing';
          this.selectedAran = this.event.aran;
        } else {
          this.aranOption = 'none';
        }
      }
    },
    fetchArans() {
      this.loadingArans = true;
      getApi()
        .then(api => {
          return api.get("/aran");
        })
        .then(({ data }) => {
          // Handle the response structure with results array
          this.arans = data.results || data;
          console.log('Fetched ARANs:', this.arans);
        })
        .catch(err => {
          console.log(err);
          this.$store.dispatch("SHOW_SNACKBAR", {
            text: err.response ? err.response.data.message : err.message,
            color: "error"
          });
        })
        .finally(() => {
          this.loadingArans = false;
        });
    },
    onAranOptionChange(value) {
      console.log('ARAN option changed to:', value);
      this.$set(this, 'aranOption', value);
    },
    openPartnersDialog() {
      this.eventPartnersDialog = true;
    },
    removePartner(partnerId) {
      if (!partnerId) return;
      this.$set(this.removingPartners, partnerId, true);
      getApi()
        .then(api => {
          return api.patch(`/events/${this.$route.params.id}/remove-partner`, {
            partnerId
          });
        })
        .then(() => {
          // Refresh event to update partners list
          return this.$store.dispatch("API_GET", {
            url: `/events/${this.$route.params.id}`,
            entityType: "events",
            schema: "eventListSchema"
          });
        })
        .catch(err => {
          console.log(err);
          this.$store.dispatch("SHOW_SNACKBAR", {
            text: err.message,
            color: "error"
          });
        })
        .finally(() => {
          this.$set(this.removingPartners, partnerId, false);
        });
    }
  },

  components: {
    EventPartnersDialog
  },

  mounted() {
    console.log('CloseEventDialog mounted - ARAN data:', {
      aranOption: this.aranOption,
      newAranName: this.newAranName,
      selectedAran: this.selectedAran,
      arans: this.arans
    });
  },

  watch: {
    closeEventDialog: {
      handler: function(val) {
        console.log('CloseEventDialog watcher triggered:', val);
        if (!val) {
          this.reset();
        } else {
          let d = new Date();
          if (this.event && this.event.endDate) {
            d = new Date(this.event.endDate);
          }
          this.endDate = format(d, "YYYY-MM-DD") + "T" + format(d, "HH:mm");
          this.populateFromEvent();
          console.log('ARAN data after populate:', {
            aranOption: this.aranOption,
            eventAran: this.event ? this.event.aran : null
          });
        }
      },
      immediate: true
    },
    aranOption: {
      handler: function(newVal) {
        console.log('ARAN option watcher triggered:', newVal);
        if (newVal === 'existing' && this.arans.length === 0) {
          this.fetchArans();
        }
      },
      immediate: true
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/events/CloseEventDialog.vue